
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    /* eslint-disable react/no-danger */
import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import FramerProvider from "@/lib/providers/FramerProvider";
import ThemeProvider from "@/lib/providers/ThemeProvider";
import "@/styles/theme/globals.scss";
import TanstackQueryProvider from "@/lib/providers/TanstackQueryProvider";
import { wrapper } from "@/lib/store";
import { setSettings } from "@/lib/store/theme/actions";
import PackageCommonSettingsProvider from "@/lib/providers/PackageCommonSettingsProvider";
import { HydrationBoundary } from "@tanstack/react-query";
import Head from "next/head";
function MainApp({ Component, ...rest }: any) {
    const { store, props } = wrapper.useWrappedStore(rest);
    if (props?.pageProps?.settings) {
        store.dispatch(setSettings(props?.pageProps?.settings));
    }
    return (<main>
      <Head>
        <Head>
          <noscript>
            <link rel="icon" href="/favicon.png"/>
            <link href={props?.pageProps?.settings?.fontFamily?.url ||
            "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"} rel="stylesheet"/>
            <link rel="stylesheet" href={`${process.env.NEXT_PUBLIC_CF_DISTRIBUTION}/fonts/FontAwesome/all.css`}/>
            <link rel="stylesheet" href={`${process.env.NEXT_PUBLIC_CF_DISTRIBUTION}/fonts/casino-icons.css`}/>
          </noscript>
        </Head>
      </Head>
      <FramerProvider>
        <TanstackQueryProvider>
          <HydrationBoundary state={props?.pageProps?.dehydratedState}>
            <PackageCommonSettingsProvider>
              <ThemeProvider>
                <CssBaseline />
                <Component {...props?.pageProps} suppressHydrationWarning/>
              </ThemeProvider>
            </PackageCommonSettingsProvider>
          </HydrationBoundary>
        </TanstackQueryProvider>
      </FramerProvider>
    </main>);
}
const __Next_Translate__Page__19a2cb5b39c__ = wrapper.withRedux(MainApp);

    export default __appWithI18n(__Next_Translate__Page__19a2cb5b39c__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  